module.exports = __webpack_public_path__ + "img/Village_Placeholder.790c3cf8.png";